import createPage from '../create-page'
import Item from './item'

export default createPage(Item, 'COLLECTION', true)



// WEBPACK FOOTER //
// ./src/components/item-page/index.js